import { CollectionValueModel } from '../collection-vlalue.model';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { NavigationItem } from '../navigation.model';
import { DataModuleWithViewItems } from './data-module-presenter.model';

export class NavigationPresenterModel {
  specificationVersion: number;
  moduleViews?: DataModuleWithViewItems[];
  systemViews?: NavigationItem[];
  serviceViewsStatus: ServiceViewsStatusModel;
}
export class NavigationPresenterModelV2 {
  specificationVersion: number;
  links?: Array<LinkPresenterModel>;
  serviceViewsStatus?: ServiceViewsStatusModel;
}

export interface ServiceViewsStatusModel {
  hasInbox?: boolean;
  hasObserverRequests?: boolean;
  hasRequests?: boolean;
  hasServiceCatalog?: boolean;
  onGoingInbox?: number;
  onGoingRequests?: number;
  onGoingObserverRequests?: number;
}
export interface UnionSidebarItemWithType
  extends DataModuleWithViewItems,
    NavigationItem {
  id: string;
}

export class LinkPresenterModel {
  id?: string;
  title: LocalizedValueModel;
  description: LocalizedValueModel;
  icon?: null | IconModel;
  url?: string;
  type?: CollectionValueModel;
  order: number;
  parent?: string;
  target?: LinkTargetPresenterModel;
  children?: LinkPresenterModel[];
  userCollections?: LinkPresenterModel[];
  sharedCollections?: LinkPresenterModel[];
  userQueries?: LinkPresenterModel[];
  isLastRelatedItem?: boolean;
  hasRelatedItems?: boolean;
}
export class LinkTargetPresenterModel {
  url?: string;
  targetId?: string;
  target_page_section_id?: string;
  target_view_action?: string;
}
